import React from "react";
import useFormValidation from "../../hooks/useFormValidation";
import validate from "../../services/validate";
import LoginComponent from "../../components/login";
import { getLocalStorage } from "../../services/auth";

const LoginContainer = () => {
  const {
    handleChange,
    handleSubmit,
    handleBlur,
    values,
    errors,
  } = useFormValidation(
    {
      id: getLocalStorage("userId"),
      password: "",
    },
    validate
  );

  return (
    <LoginComponent
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      handleBlur={handleBlur}
      values={values}
      errors={errors}
    />
  );
};

export default LoginContainer;
